import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.click = this.handleClick.bind(this)
    this.keydown = this.handleKeydown.bind(this)
    this.pointerover = this.handlePointerOver.bind(this)
    this.pointerout = this.handlePointerOut.bind(this)
    document.addEventListener("pointerover", this.pointerover)
    document.addEventListener("pointerout", this.pointerout)
    document.addEventListener("click", this.click)
    document.addEventListener("keydown", this.keydown)
  }

  disconnect() {
    window.clearTimeout(this.hoverCloseTimer)
    document.removeEventListener("pointerover", this.pointerover)
    document.removeEventListener("pointerout", this.pointerout)
    document.removeEventListener("click", this.click)
    document.removeEventListener("keydown", this.keydown)
  }

  handleClick(event) {
    const dismiss = event.target.closest("[data-bs-dismiss]")
    if (dismiss) {
      event.preventDefault()
      this.dismiss(dismiss)
      return
    }

    const modalToggle = event.target.closest("[data-bs-toggle='modal']")
    if (modalToggle) {
      event.preventDefault()
      this.showModal(document.querySelector(this.targetSelector(modalToggle)))
      return
    }

    const dropdownToggle = event.target.closest("[data-bs-toggle='dropdown']")
    if (dropdownToggle) {
      event.preventDefault()
      this.toggleDropdown(dropdownToggle)
      return
    }

    const collapseToggle = event.target.closest("[data-bs-toggle='collapse']")
    if (collapseToggle) {
      event.preventDefault()
      this.toggleCollapse(collapseToggle)
      return
    }

    if (!event.target.closest(".dropdown")) {
      this.closeDropdowns()
    }
  }

  handleKeydown(event) {
    if (event.key !== "Escape") return

    const openDropdown = document.querySelector(".dropdown.show")
    const toggle = openDropdown && openDropdown.querySelector("[data-bs-toggle='dropdown']")
    this.closeDropdowns()
    if (toggle) toggle.focus()
    document.querySelectorAll(".navigation-redesign .navbar-collapse.show").forEach((menu) => {
      const trigger = document.querySelector(`[aria-controls="${menu.id}"]`)
      // Close the mobile menu only when Escape did not just close a submenu.
      if (!openDropdown) {
        menu.classList.remove("show")
        if (trigger) {
          trigger.setAttribute("aria-expanded", "false")
          trigger.focus()
        }
      }
    })
    this.hideModal(document.querySelector(".modal.show"))
  }

  hoverDropdown(event) {
    if (event.pointerType !== "mouse" || !window.matchMedia("(min-width: 1200px)").matches) return null

    const dropdown = event.target.closest(".navigation-redesign .dropdown")
    if (!dropdown || (event.relatedTarget && dropdown.contains(event.relatedTarget))) return null
    return dropdown
  }

  handlePointerOver(event) {
    const dropdown = this.hoverDropdown(event)
    if (!dropdown) return

    window.clearTimeout(this.hoverCloseTimer)
    this.closeDropdowns(dropdown)
    if (!dropdown.classList.contains("show")) dropdown.dataset.hoverOpened = "true"
    this.setDropdownOpen(dropdown, true)
  }

  handlePointerOut(event) {
    const dropdown = this.hoverDropdown(event)
    if (!dropdown) return

    window.clearTimeout(this.hoverCloseTimer)
    this.hoverCloseTimer = window.setTimeout(() => {
      if (!dropdown.querySelector(":focus-visible")) this.setDropdownOpen(dropdown, false)
    }, 200)
  }

  setDropdownOpen(dropdown, open) {
    dropdown.classList.toggle("show", open)
    const toggle = dropdown.querySelector("[data-bs-toggle='dropdown']")
    if (toggle) toggle.setAttribute("aria-expanded", open)
    const menu = dropdown.querySelector(".dropdown-menu")
    if (menu) menu.classList.toggle("show", open)
    if (!open) delete dropdown.dataset.hoverOpened
  }

  dismiss(element) {
    const dismissAction = element.dataset.bsDismiss

    if (dismissAction === "alert") {
      const alert = element.closest(".alert")
      if (alert) alert.remove()
    } else if (dismissAction === "modal") {
      this.hideModal(element.closest(".modal"))
    }
  }

  toggleDropdown(toggle) {
    const dropdown = toggle.closest(".dropdown")
    if (!dropdown) return

    const shouldOpen = dropdown.dataset.hoverOpened === "true" || !dropdown.classList.contains("show")
    delete dropdown.dataset.hoverOpened
    this.closeDropdowns(dropdown)
    this.setDropdownOpen(dropdown, shouldOpen)
  }

  closeDropdowns(except = null) {
    document.querySelectorAll(".dropdown.show").forEach((dropdown) => {
      if (dropdown !== except) this.setDropdownOpen(dropdown, false)
    })
  }

  toggleCollapse(toggle) {
    const target = document.querySelector(this.targetSelector(toggle))
    if (!target) return

    const shouldOpen = !target.classList.contains("show")
    target.classList.toggle("show", shouldOpen)
    toggle.setAttribute("aria-expanded", shouldOpen)
  }

  showModal(modal) {
    if (!modal) return

    modal.style.display = "block"
    modal.removeAttribute("aria-hidden")
    modal.setAttribute("aria-modal", "true")
    modal.setAttribute("role", "dialog")
    modal.offsetWidth
    modal.classList.add("show")
    document.body.classList.add("modal-open")
    this.showBackdrop()
  }

  hideModal(modal) {
    if (!modal) return

    modal.classList.remove("show")
    modal.style.display = "none"
    modal.setAttribute("aria-hidden", "true")
    modal.removeAttribute("aria-modal")
    modal.removeAttribute("role")
    document.body.classList.remove("modal-open")
    this.hideBackdrop()
  }

  showBackdrop() {
    if (document.querySelector(".modal-backdrop")) return

    const backdrop = document.createElement("div")
    backdrop.className = "modal-backdrop fade show"
    document.body.appendChild(backdrop)
  }

  hideBackdrop() {
    document.querySelectorAll(".modal-backdrop").forEach((backdrop) => backdrop.remove())
  }

  targetSelector(element) {
    return element.dataset.bsTarget
  }
}
